"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
exports.getMonthInfo = getMonthInfo;
exports.getWeekDay = getWeekDay;

function getMonthInfo(year, month, startDay) {
  var weeks = [];
  var firstDate = new Date(year, month, 1);
  var lastDate = new Date(year, month + 1, 0);
  var numDays = lastDate.getDate();
  var start = 1;
  var end = firstDate.getDay() === 0 ? 1 : 7 - firstDate.getDay() + 1;

  if (startDay === 'sunday') {
    end = 7 - firstDate.getDay();
  }

  while (start <= numDays) {
    weeks.push({
      start: start,
      days: end - start + 1
    });
    start = end + 1;
    end += 7;
    end = start === 1 && end === 8 ? 1 : end;

    if (end > numDays) {
      end = numDays;
    }
  }

  return {
    totalWeek: weeks,
    totalDay: numDays
  };
}

function getWeekDay(startWeekDay, weekDayFormat) {
  var start = 1;

  if (startWeekDay === 'sunday') {
    start = 0;
  }

  for (var i = start; i < start + 7; i++) {}

  var arrWeekDay = weekDayFormat === 'dd' ? ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'] : weekDayFormat === 'ddd' ? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] : ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  if (startWeekDay === 'sunday') {
    var last = arrWeekDay.pop();
    arrWeekDay.unshift(last);
  }

  return arrWeekDay;
}

function debounce(func, wait) {
  var timeout; // This is the function that is returned and will be executed many times
  // We spread (...args) to capture any number of parameters we want to pass

  return function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // The callback function to be executed after
    // the debounce time has elapsed
    var later = function later() {
      // null timeout to indicate the debounce ended
      timeout = null; // Execute the callback

      func.apply(void 0, args);
    }; // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the
    // inside of the previous setTimeout


    clearTimeout(timeout); // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs Node)

    timeout = setTimeout(later, wait);
  };
}

;